import Vue from "vue/dist/vue.esm";

import store from './library/js/store/view-room-details.store'

import ViewRoomDetailsContainer from "./library/js/components/view-room-details/container.vue";

Vue.component('view-room-details-container', ViewRoomDetailsContainer);

window.viewRoomDetailsVueApp = new Vue({
    store: store
})
    .$mount("#container");